import React from 'react';
import { formatFileSize } from '../utils/pdfPageUtils';
import './PDFPageRemover.css';

function PageRemovalResults({ results, onClearResults, onRetry, isProcessing }) {
  if (!results || results.length === 0) {
    return null;
  }

  const successCount = results.filter(r => r.success).length;
  const failedCount = results.filter(r => !r.success).length;

  return (
    <div className="page-removal-results">
      <div className="results-header">
        <h2>Processing Results</h2>
        <button
          className="btn btn-outline"
          onClick={onClearResults}
          disabled={isProcessing}
          style={{
            fontSize: '14px',
            padding: '8px 16px'
          }}
        >
          🗑️ Clear Results
        </button>
      </div>

      {successCount > 0 && failedCount === 0 && (
        <div className="results-summary success">
          ✅ Processing completed successfully!
        </div>
      )}

      {failedCount > 0 && (
        <div className="results-summary mixed">
          {successCount > 0
            ? `⚠️ ${successCount} successful, ${failedCount} failed`
            : `❌ ${failedCount} failed`
          }
          {failedCount > 0 && (
            <button
              className="btn retry-btn"
              onClick={onRetry}
              disabled={isProcessing}
              style={{
                marginLeft: '15px',
                fontSize: '14px',
                padding: '6px 12px'
              }}
            >
              🔄 Retry
            </button>
          )}
        </div>
      )}

      <div className="results-list">
        {results.map((result, index) => (
          <div
            key={index}
            className={`result-item ${result.success ? 'success' : 'error'}`}
          >
            <div className="result-content">
              <div className="result-header">
                <div className="result-status">
                  {result.success ? '✅' : '❌'}
                </div>
                <div className="result-description">
                  {result.description || 'Page removal operation'}
                </div>
              </div>

              {result.success ? (
                <div className="success-details">
                  <div className="file-info">
                    <div className="file-name">
                      📄 {result.fileName}
                    </div>
                    <div className="file-stats">
                      {result.fileSize && (
                        <span className="stat">
                          Size: {formatFileSize(result.fileSize)}
                        </span>
                      )}
                      <span className="stat">
                        Original: {result.originalPages} pages
                      </span>
                      {result.removedCount > 0 && (
                        <span className="stat removed">
                          Removed: {result.removedCount} pages
                        </span>
                      )}
                      {result.keptCount > 0 && (
                        <span className="stat kept">
                          Final: {result.keptCount} pages
                        </span>
                      )}
                    </div>
                  </div>

                  {result.removedPages && result.removedPages.length > 0 && (
                    <div className="page-details">
                      <strong>Removed pages:</strong> {result.removedPages.join(', ')}
                    </div>
                  )}

                  {result.keptPages && result.keptPages.length > 0 && (
                    <div className="page-details">
                      <strong>Kept pages:</strong> {result.keptPages.join(', ')}
                    </div>
                  )}

                  <div className="download-notice">
                    📥 Your processed PDF has been automatically downloaded
                  </div>
                </div>
              ) : (
                <div className="error-details">
                  <div className="error-message">
                    <strong>Error:</strong> {result.error}
                  </div>
                  <div className="error-help">
                    Please check your PDF file and removal settings, then try again.
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PageRemovalResults;